import * as yup from 'yup';
import { Reservation } from '../entities';
import { emptyStringToNullTransform, toStringSchema } from './utils';

export const schemaReservation = yup.object().shape<Reservation>(
    {
        date: toStringSchema(
            yup
                .date()
                .transform(emptyStringToNullTransform)
                .min(new Date(), 'Cette date est invalide')
                .defined()
                .when('activite', {
                    is: (activite) => Boolean(activite),
                    then: yup.date().required('Une date est requise pour chaque activités'),
                }),
        ),
        activite: yup
            .number()
            .transform(emptyStringToNullTransform)
            .nullable()
            .when('date', {
                is: (date) => Boolean(date),
                then: yup.number().required('Une activité est requise pour chaque date'),
            }),
        commentaire: yup.string().defined(),
        autobus: yup.bool().defined(),
    },
    [
        ['activite', 'date'],
        ['date', 'activite'],
    ],
);
